import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { ErrorToast } from "utils/toast";
import FullScreenLoader from "components/FullScreenLoader";

const Login = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { login, isAuthenticated } = useAuth();

  useEffect(() => {
    const handleTokenLogin = async () => {
      try {
        const accessToken = searchParams.get("accessToken");

        if (!accessToken) {
          ErrorToast("No access token provided");
          navigate("/");
          return;
        }

        // Store the token in localStorage
        localStorage.setItem("accessToken", accessToken);

        // Decode JWT to get user info (optional - for basic user data)
        // You can also call an API endpoint to get complete user details
        const base64Url = accessToken.split(".")[1];
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        const jsonPayload = decodeURIComponent(
          atob(base64)
            .split("")
            .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
            .join(""),
        );
        const tokenData = JSON.parse(jsonPayload);

        // Create user object - adjust fields based on your backend response
        const userData = {
          id: tokenData.sub,
          tokenId: tokenData.tokenId,
          accessToken: accessToken,
          isEligibleForSubscription: tokenData.isEligibleForSubscription,
          isAlreadySubscribed: tokenData.isAlreadySubscribed,
        };

        // Log in the user
        login(userData);
        // SuccessToast("Logged in successfully!");

        // Redirect to requested page (defaults to /questionnaire if not specified)
        const redirectTo = searchParams.get("redirectTo") || "/questionnaire";
        navigate(redirectTo);
      } catch (error) {
        console.error("Token login error:", error);
        ErrorToast("Failed to authenticate with token");
        navigate("/");
      }
    };

    if (!isAuthenticated) {
      handleTokenLogin();
    } else {
      // Already authenticated, redirect to requested page
      const redirectTo = searchParams.get("redirectTo") || "/questionnaire";
      navigate(redirectTo);
    }
  }, [searchParams, navigate, login, isAuthenticated]);

  return <FullScreenLoader />;
};

export default Login;
